import { hooks, methods, components } from './utils/reduxStore';
import * as ObjectExtensions from "../utils/CoreExtensions/ObjectExtensions";


// hooks
export const useDispatch = hooks.useDispatch;
export const useSelector = hooks.useSelector;

// methods
export const shallowEqual = methods.shallowEqual;
export const createSlice = methods.createSlice;

// components
export const Provider = components.Provider;


// filerActions
export const handleFilters = (prevState, action) => {
  const {uId, data: newStateData} = action.payload;
  prevState.form[uId].snapshots.current = newStateData;
};

export const handleFilterConfigs = (prevState, action) => {
  const {uId, data: newConfigsData} = action.payload;
  prevState.form[uId].configs = newConfigsData;
};

export const handleDefaultParams = (prevState, action) => {
  const newDefaultParamsData = action.payload.data;
  prevState.defaultParams = newDefaultParamsData;
};

export const replaceFilters = (_prevState, action) => {
  return action.payload.data;
};

export const deepMergeFilters = (prevState, action) => {
  const newStore = ObjectExtensions.deepMerge(prevState, action.payload.data);
  return newStore;
};

export const restoreFilterSnapshot = (prevState, action) => {
  const {uId, data: restoreTo} = action.payload;
  prevState.form[uId].snapshots.current = prevState.form[uId].snapshots[restoreTo];
};

export const copyFilterSnapshot = (prevState, action) => {
  const {uId, data: {copyFrom, copyTo }} = action.payload;
  prevState.form[uId].snapshots[copyTo] = prevState.form[uId].snapshots[copyFrom];
};

export const applyFilter = (prevState, action) => {
  const uId = action.payload.uId;
  prevState.form[uId].configs.isApplied = true;
  prevState.form[uId].configs.appliedTime = Date.now();
};

export const removeFilter = (prevState, action) => {
  const uId = action.payload.uId;
  prevState.form[uId].configs.isApplied = false;
  prevState.form[uId].configs.appliedTime = 0;
};